import { render } from "./vendor.vue?vue&type=template&id=5cca973e&scoped=true"
import script from "./vendor.vue?vue&type=script&lang=js"
export * from "./vendor.vue?vue&type=script&lang=js"

import "./vendor.vue?vue&type=style&index=0&id=5cca973e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cca973e"]])

export default __exports__